<template>
  <v-app
    v-if="!isEmpty(initialData)"
    style="background: #ffffff; min-height: auto"
  >
    <v-container fluid class="pa-0">
      <SalesBanner
        :group-id="groupId"
        :allowed-group-id="availableSales"
      />

      <div class="app-container">
        <promo-slider
          :slides="initialData.promoSlides"
          class="mt-4"
        ></promo-slider>
      </div>

      <quick-navigation :items="initialData.quickNavigation"></quick-navigation>

      <popular-brands
        :items="popularBrands"
        :is-brand-menu="isBrandMenu"
        @toggle-brands-menu="isBrandMenu = !isBrandMenu"
      ></popular-brands>

      <brands-menu
        :items="preparedBrands"
        :is-brand-menu="isBrandMenu"
      ></brands-menu>

      <div class="app-container mt-6">
        <processes-menu :items="initialData.processes"></processes-menu>
      </div>

      <newsletter-dialog
        :is-visible.sync="newsletterDialog"
        :categories="newsletterCategories"
        :email="newsletterUser.email"
        :name="newsletterUser.name"
        @submit="openSnackBar"
      >
      </newsletter-dialog>

      <bugreport-dialog
        :is-visible.sync="bugreportDialog"
        @submit="openSnackBar"
      >
      </bugreport-dialog>

      <snackbar
        v-model="snackbar"
        :snackbar="snackbar"
        :snackbar-data="snackbarData"
      >
      </snackbar>
    </v-container>

    <to-top-button></to-top-button>
  </v-app>
</template>

<script>
// Components
import PromoSlider from "@/pages/index/components/promo-slider/PromoSlider";
import QuickNavigation from "@/pages/index/components/quick-navigation/QuickNavigation";
import PopularBrands from "@/pages/index/components/popular-brands/PopularBrands";
import BrandsMenu from "@/pages/index/components/brands-menu/BrandsMenu";
import Snackbar from "@/components/Snackbar";
import ToTopButton from "@/components/ToTopButton";
import SalesBanner from "./components/sales-banner/SalesBanner";

// Mixins
import UserType from "@/mixins/UserType";
import PriceType from "@/mixins/PriceType";

// Utils
import isEmpty from "lodash/isEmpty";
import ProcessesMenu from "@/pages/index/components/processes-menu/ProcessesMenu";

export default {
  name: "App",
  components: {
    SalesBanner,
    ProcessesMenu,
    BrandsMenu,
    PopularBrands,
    QuickNavigation,
    PromoSlider,
    Snackbar,
    ToTopButton
  },
  mixins: [PriceType, UserType],
  provide() {
    return {
      mess: this.mess
    };
  },
  data() {
    return {
      initialData: window.initialData || {},
      initialDataWidgets: window.initialDataWidgets,
      newsletterCategories: [],
      newsletterUser: {
        email: "",
        name: ""
      },
      newsletterDialog: false,
      bugreportDialog: false,
      snackbar: false,
      snackbarData: null,
      isBrandMenu: true,
      popularBrands: []
    };
  },
  methods: {
    isEmpty: isEmpty,
    openSnackBar(data) {
      this.snackbar = true;
      this.snackbarData = data;
    }
  },
  computed: {
    preparedBrands() {
      const columns = 3;
      const result = new Array(columns).fill({});
      let length_ = Object.keys(this.initialData.brands)?.length;
      while (length_ % columns !== 0) {
        length_ = length_ + 1;
      }
      const columnLength = length_ / columns;
      let currentColumn = 0;
      Object.keys(this.initialData.brands).forEach((k, i) => {
        result[currentColumn] = {
          ...result[currentColumn],
          [k]: this.initialData.brands[k]
        };
        if (i + 1 >= columnLength * (currentColumn + 1))
          currentColumn = currentColumn + 1;
      });
      return result;
    },
    groupId() {
      return this.initialData.user_salesChannel || 0;
    },
    availableSales() {
      return this.initialData.availableSales || [];
    },
    mess() {
      return this.initialData.mess || {};
    }
  },
  created() {
    if (isEmpty(this.initialData)) {
      throw new Error("initialData does not exist or empty");
    } else {
      this.$store.dispatch("setMess", window.initialData.mess);

      this.popularBrands = this.initialData.popularBrands.map(b => ({
        ...b,
        currentImage: b.staticImage
      }));
    }

    if (!isEmpty(this.initialDataWidgets)) {
      const {
        newsletter_categories,
        user_email,
        user_name
      } = this.initialDataWidgets.newsletterinitial;

      this.newsletterCategories = newsletter_categories || [];
      this.newsletterUser.email = user_email || "";
      this.newsletterUser.name = user_name || "";
      this.$store.dispatch("setMess", this.initialDataWidgets.mess);
    }
  }
};
</script>

<style lang="scss">
@import "../../styles/common-pages";
@import "styles/index";
</style>
